// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__31DhK","gfeWrapper":"CalendarEvent_gfeWrapper__gsa4b"};